import script from "./AdviceDeliveryReactionAddNewDocumentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdviceDeliveryReactionAddNewDocumentForm.vue?vue&type=script&setup=true&lang=ts"

import "./AdviceDeliveryReactionAddNewDocumentForm.vue?vue&type=style&index=0&id=ed6ae95a&lang=sass"

const __exports__ = script;

export default __exports__